import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Header } from "@/core/navigation/Header";
import { ModuleDrawer } from "@/core/navigation/ModuleDrawer";
import { NotificationsPanel } from "@/core/navigation/NotificationsPanel";
import { BottomTabBar } from "@/core/navigation/BottomTabBar";
import { getNavMeta } from "@/core/navigation/navMeta";
import { useMeusConvites } from "@/core/hooks/useConvites";
import { useAuth } from "@/core/hooks/useAuth";
import { useUsuariosPendentes } from "@/core/hooks/useUsuarios";
import { useMinhasNotificacoes } from "@/core/hooks/useNotificacoes";

/**
 * Shell das telas autenticadas: cabeçalho unificado + drawer de módulos +
 * painel de notificações em volta do <Outlet/>. Cada página mantém seu
 * próprio <main> (larguras diferentes), então o layout não impõe container.
 */
export function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // Convites de ministério pendentes (DA-003) acendem a bolinha do sino.
  const { data: convites } = useMeusConvites();
  // Cadastros pendentes de aprovação também acendem o sino, só para o Admin
  // da Plataforma (é quem aprova).
  const { ehAdminPlataforma } = useAuth();
  const { data: pendentes } = useUsuariosPendentes();
  const temCadastrosPendentes = ehAdminPlataforma && !!pendentes?.length;
  // ARQ-04/BUG-03/BUG-05: notificações de reserva (aprovada/rejeitada/criada
  // por evento) também acendem a bolinha do sino enquanto não forem lidas.
  const { data: notificacoes } = useMinhasNotificacoes();
  const temNotificacoesNaoLidas = !!notificacoes?.some((n) => !n.lida);

  useEffect(() => {
    setMenuOpen(false);
    setNotifOpen(false);
  }, [location.pathname]);

  // Raiz (parent null) = Home, com sino/Elos; demais telas ganham a seta ‹.
  const meta = getNavMeta(location.pathname);
  const back = meta.parent
    ? { title: meta.title, onBack: () => navigate(meta.parent as string) }
    : undefined;

  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <Header
        onOpenMenu={() => setMenuOpen(true)}
        onOpenNotif={() => setNotifOpen(true)}
        back={back}
        temNotificacoes={!!convites?.length || temCadastrosPendentes || temNotificacoesNaoLidas}
      />
      {/* pb reserva espaço para a barra fixa inferior não cobrir o fim da tela
          (Sprint 3 — redesign Elos), sem precisar mexer no padding de cada página. */}
      <div className="flex-1 pb-20">
        <Outlet />
      </div>
      <ModuleDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
      <NotificationsPanel open={notifOpen} onClose={() => setNotifOpen(false)} />
      <BottomTabBar />
    </div>
  );
}
